import { runExtractValue, runUpdatePropValue } from "../../../executor";
import useWatcher from "../../useWatcher";
import useAddEvent from "../core/useAddEvent";
import useGroupControl from "../core/useGroupControl";

const radio = (name, props, node) => {

    const { onCreated, onDestroy, onPropChanges } = useWatcher(props, node, [name]);
    const groupControl = useGroupControl(name, props, node);

    const queryValue = () => runExtractValue(props, name);

    let detachEvent;
    const attachEvent = () => {
        detachEvent = useAddEvent(['change'], node, (e) => {
            const value = e.target.value;
            if (e.target.checked) {
                runUpdatePropValue(props, name, value);
            }
        })
    }

    onCreated(() => {
        attachEvent();
        groupControl.controls.forEach(ctrl => {
            ctrl.checked = ctrl.value === queryValue();
        })
    })

    onPropChanges(() => {
        groupControl.controls.forEach(ctrl => {
            ctrl.checked = ctrl.value === queryValue();
        })
    })
    onDestroy(() => {
        if (typeof detachEvent === 'function') {
            detachEvent();
        }
    })
    return detachEvent;
};
export default radio;